export default "__VITE_ASSET__BwTPEgEY__"